import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region NUMBER

function _Number(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Number);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Number = withLabelTokenParsing(_Number, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.PurchaseOrderNumber:
            if (!Utilities.isNullOrWhitespace(data.Number)) {
                replaceString = data.Number;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Purchase Order #:', token: Token.PurchaseOrderNumber }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Order #:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.PurchaseOrderNumber}}`, token: Token.PurchaseOrderNumber }))
    }
};

// #endregion NUMBER

export {
    Number as Component,
    Tokens,
    TypeConfig
}